import React, { useState,useEffect } from "react";
import tw from "twin.macro";
import 'twin.macro'
import styled from "styled-components";
import {css} from "styled-components/macro";
import {Link, useLocation} from 'react-router-dom'


import {useAppDispatch,loadMoreNews,useAppSelector} from '../../redux'
import AdComponent from '../AdComponent.js'
import ReadMoreButton from "components/ReadMoreButton.js";

const Heading = tw.text`lg:text-2xl md:text-xl font-bold  text-gray-900`;
const Posts = tw.div`mt-2 lg:ml-0 xsm:-ml-1 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 md:gap-3 lg:gap-4 `;


const Post = tw.div`cursor-pointer flex flex-col lg:w-72`;
const Image = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`lg:h-56  xsm:h-48 lg:w-72 bg-cover bg-center`}
`;
const Info = tw.div`py-2`;
const Title = tw.div`font-bold text-lg lg:text-base line-clamp-2 text-gray-900`;


const TextTwo = tw.h5`text-xs font-semibold text-gray-900 border-b-2 py-1`
const Div = tw.h5`mx-5 lg:m-0`





export default ({name = "News", news}) => {
  const dispatch = useAppDispatch()
  console.log(news.length);

  const isEndReached = useAppSelector(state => state.news.isEndReached);
  console.log(isEndReached, 'newsfeed');
  const onLoadMoreClick = () => {
   dispatch(loadMoreNews())
  };
  return (
  
          <Div>
            <Heading>{name}</Heading>
 
            <Posts >
        {news && news.map((item) => (
                
              <Link to={`/news/${item.id}`}  key={item.id}>
              <Post>
                <Image imageSrc={item.cover_url} />
                <Info>
                  <Title>{item.title}</Title>
                <TextTwo>{`${new Date(
                  item.createdAt.seconds * 1000 + item.createdAt.nanoseconds / 1000000).getDate().toString()}/${new Date(
                    item.createdAt.seconds * 1000 + item.createdAt.nanoseconds / 1000000).getMonth().toString()}/${new Date(
                      item.createdAt.seconds * 1000 + item.createdAt.nanoseconds / 1000000).getFullYear().toString()}`}</TextTwo>
                </Info>
              </Post>
             </Link>
          ))}
          </Posts>
      {isEndReached  ? null  : <ReadMoreButton handleLoadMoreData={onLoadMoreClick} link="news" />} 
          </Div>
      
  );
};

